import { bool, number, string } from 'prop-types';

export const propTypes = {
  header: string,
  itemId: string.isRequired,
  storeId: string,
  showPrimaryImage: bool,
  maxHorizontalPods: number
};

export const defaultProps = {
  header: 'More in This Collection',
  maxHorizontalPods: 5,
  storeId: undefined,
  showPrimaryImage: true
};
